module.exports = __webpack_public_path__ + "static/media/error-unauthorized.ec776593.svg";